import { ProgramaVerificacionViewModel } from '../../../_campanias/programasverificacion/datosbasicos/pvcam-datosbasicos.types';

export class NavMenuServiceProgramaVerificacion {
    protected _currentProgramaVerificacion: ProgramaVerificacionViewModel | undefined = new ProgramaVerificacionViewModel();

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetProgramaVerificacionData(): void {
        this._currentProgramaVerificacion = new ProgramaVerificacionViewModel();
    }

    protected set currentProgramaVerificacion(value: ProgramaVerificacionViewModel) {
        this._currentProgramaVerificacion = value;
        this.refresh();
    }

    protected get currentProgramaVerificacion(): ProgramaVerificacionViewModel {
        if (!this._currentProgramaVerificacion) {
            this._currentProgramaVerificacion = new ProgramaVerificacionViewModel();
        }
        return this._currentProgramaVerificacion;
    }

    public updateMenuServiceForProgramaVerificacion(id: number, IdEstadoPv: number): void {
        const vm = new ProgramaVerificacionViewModel();
        vm.Id = id;
        vm.IdEstadoPv = IdEstadoPv;
        this.currentProgramaVerificacion = vm;
    }

    public clearMenuServiceForProgramaVerificacion(): void {
        const vm = new ProgramaVerificacionViewModel();
        vm.Id = 0;
        this.currentProgramaVerificacion = vm;
    }

    protected get isProgramaVerificacionSelected(): boolean {
        if (this.currentProgramaVerificacion && this.currentProgramaVerificacion.Id) {
            return this.currentProgramaVerificacion.Id > 0;
        } else return false;
    }
}
